<template>
  <div class="card-box">
    <div class="title">{{ isApp ? '- 准考证 -' : '报名成功' }}</div>
    <div class="nameAndPhone">
      <div class="name">{{ signUpParams.fullName }}</div>
      <div class="phone">
        {{ signUpParams.phoneNumber.slice(0, 3) + '****' + signUpParams.phoneNumber.slice(7) }}
      </div>
    </div>
    <div class="school">{{ signUpParams.school }}</div>
    <div class="major">{{ signUpParams.major }}专业</div>
    <div class="number">
      {{ signUpParams.address }} {{ signUpParams.studentID ? signUpParams.studentID : '' }}
    </div>
    <div class="teacher" v-if="signUpParams.teacherName">
      辅导老师 {{ signUpParams.teacherName }}
    </div>
    <div v-if="showArea" class="bottom-line">
      <div class="group-line">
        {{
          signUpParams.groupType == 1
            ? '高职/高专'
            : signUpParams.groupType == 2
            ? '本科'
            : '研究生'
        }}组
      </div>
      <div class="area">{{ currentAreaName }}</div>
      <!-- <div class="result" v-show="showResult" @click="$emit('clickResult')">
        成绩
      </div> -->
    </div>
    <div class="group" v-else>
      {{
        signUpParams.groupType == 1 ? '高职/高专' : signUpParams.groupType == 2 ? '本科' : '研究生'
      }}组
    </div>
    <!-- <div
      v-if="isApp && !showArea && pageName != 'result'"
      class="edit"
      @click="$emit('clickEditCard')"
    ></div> -->
  </div>
</template>

<script>
// 报名数据
// signUpParams: {
//   phoneNumber: '', // 手机号
//   verificationCode: '', // 验证码
//   channel: '100003', // 活动编号
//   fullName: '', // 姓名
//   school: '', // 在读学校
//   major: '', // 在读专业
//   address: '', // 学校地址
//   groupType: '', // 组别 1-高职高专 2-本科 3-研究生
//   teacherName: '', // 指导老师姓名
//   studentID: '', // 学号
// }
export default {
  props: ['signUpParams', 'isApp', 'showArea', 'currentAreaName', 'pageName', 'showResult'],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.card-box {
  position: relative;
  height: 6.4rem;
  padding: 0.14rem 0.9rem 0;
  background: url(./img/icon-card.png) no-repeat top center;
  background-size: 100%;
  .title {
    height: 0.5rem;
    font-size: 0.36rem;
    font-weight: 600;
    color: #ffffff;
    line-height: 0.5rem;
    text-align: center;
  }
  .name {
    height: 0.74rem;
    margin-top: 0.48rem;
    margin-bottom: 0.26rem;
    font-size: 0.52rem;
    font-weight: 600;
    color: #373d52;
    line-height: 0.74rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  .phone,
  .school,
  .major,
  .number,
  .teacher {
    position: relative;
    width: 5.32rem;
    height: 0.34rem;
    margin-top: 0.14rem;
    padding-left: 0.38rem;
    font-size: 0.24rem;
    font-weight: 600;
    color: #546079;
    line-height: 0.34rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    &::before {
      position: absolute;
      left: 0;
      content: '';
      width: 0.32rem;
      height: 0.32rem;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }
  .phone::before {
    background-image: url(./img/icon-phone.png);
  }
  .school::before {
    background-image: url(./img/icon-school.png);
  }
  .major::before {
    background-image: url(./img/icon-major.png);
  }
  .number::before {
    background-image: url(./img/icon-number.png);
  }
  .teacher::before {
    background-image: url(./img/icon-teacher.png);
  }
  .group {
    position: absolute;
    bottom: 0.75rem;
    left: 0;
    right: 0;
    width: 2.2rem;
    height: 0.56rem;
    margin: 0 auto;
    padding: 0 0.28rem;
    background: rgba(179, 34, 33, 0.1);
    border-radius: 0.28rem;
    font-size: 0.28rem;
    font-weight: 600;
    color: #b32221;
    line-height: 0.56rem;
    text-align: center;
  }
  .bottom-line {
    position: absolute;
    bottom: 0.75rem;
    left: 0;
    right: 0;
    padding: 0 0.9rem;
    .group-line {
      position: relative;
      display: inline-block;
      height: 0.56rem;
      margin: 0 auto;
      padding: 0 0.28rem;
      background: rgba(179, 34, 33, 0.1);
      border-radius: 0.28rem;
      font-size: 0.28rem;
      font-weight: 600;
      color: #b32221;
      line-height: 0.56rem;
      text-align: center;
    }
    .area {
      position: relative;
      display: inline-block;
      height: 0.56rem;
      margin: 0 auto 0 0.08rem;
      padding: 0 0.28rem;
      background: rgba(179, 34, 33, 0.1);
      border-radius: 0.28rem;
      font-size: 0.28rem;
      font-weight: 600;
      color: #b32221;
      line-height: 0.56rem;
      text-align: center;
    }
    .result {
      position: absolute;
      bottom: 0;
      right: 0.9rem;
      height: 0.56rem;
      font-size: 0.28rem;
      font-weight: 600;
      color: #b32221;
      line-height: 0.6rem;
      text-decoration: underline;
      &::before {
        position: absolute;
        top: 0.08rem;
        left: -0.4rem;
        width: 0.4rem;
        height: 0.4rem;
        content: '';
        background: url(./img/icon-find-2.png) no-repeat center / 100%;
      }
    }
  }
  .edit {
    position: absolute;
    top: 0.44rem;
    right: 0.64rem;
    width: 0.48rem;
    height: 0.48rem;
    background: url(./img/icon-edit.png) no-repeat center;
    background-size: 100%;
  }
}
</style>
